export default __webpack_public_path__ + "static/media/RAFAnimation.c1fb1680.gif";